import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import {Button, ContentLayout, Header, Link, Modal} from "@amzn/awsui-components-react";
import RecentUAT from "./recentUAT";
import RavenWizard from "./RavenWizard";
import React, {useState} from "react";

export const UATLandingPage = () => {
  const [isWizardVisible, setIsWizardVisible] = useState(false);


  return (
      <><SpaceBetween size="xl">
        <ContentLayout
            defaultPadding
            header={<SpaceBetween size="m">
              <Header
                  variant="h1"
                  info={<Link
                      href={"https://w.amazon.com/bin/view/AmazonVideo/TRACK/Systems/Cyberman/CybermanShadowTesting"}
                      variant="info"
                  >
                    Info
                  </Link>}
                  description="The all-in-one UAT platform."
              >
                Raven
              </Header>
              <Button onClick={() => setIsWizardVisible(true)}>New UAT Project</Button>
            </SpaceBetween>}
        >
          <SpaceBetween size={"xl"}>
            <RecentUAT/>
          </SpaceBetween>
        </ContentLayout>
      </SpaceBetween><Modal
          visible={isWizardVisible}
          onDismiss={() => setIsWizardVisible(false)}
          size="max"
          closeAriaLabel="Close modal"
      >
        <RavenWizard onClose={() => setIsWizardVisible(false)}/>
      </Modal>
      </>
  );
};